import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectPromises,
  selectIsLoading,
  selectLastPromise,
  selectPromisesCount,
} from "redux-toolkit/promises/selectors";
import {
  getPromisesAsync,
  getNextPromisesAsync,
} from "redux-toolkit/promises/actions";

const usePromises = (filters = {}) => {
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const promises = useSelector(selectPromises);
  const isLoading = useSelector(selectIsLoading);
  const last = useSelector(selectLastPromise);
  const count = useSelector(selectPromisesCount);

  useEffect(() => {
    dispatch(getPromisesAsync(filters));
  }, [dispatch, filters]);

  const getNextPage = () => {
    if (last && count > promises.length) {
      dispatch(getNextPromisesAsync({ last, filters }));
      setPage(page + 1);
    }
  };

  return {
    promises,
    isLoading,
    hasMoreItems: count > promises.length,
    count,
    page,
    setPage,
    getNextPage,
  };
};

export default usePromises;
